




























































































































































































































































































































































































































































































import { apiUrl } from "@/domain";
import Vue from "vue";
import VueUploadComponent from "vue-upload-component";
import { Autocomplete } from "vue2-google-maps";
import ApiService from "../../services/ApiService";
import ImageCompressor from "compressorjs";
import OrgRelationshipModal from "../../modals/OrgRelationshipModal.vue";
import OrgUsersModal from "../../modals/OrgUsersModal.vue";
export default Vue.extend({
  data() {
    return {
      form: {
        type: {},
        email: "",
        phone: "",
        total_students: null,
        registration_type: "REGULAR",
        organization_logo: null,
        front_image: null,
      },
      newAddress: {},
      councils: [],
      organization_id: null,
      loading: false,
      edit: false,
      showingForm: false,
      cropper: false,
      centerPosition: { lat: 52.009865, lng: -0.118092 },
      zoomLevel: 7,
      marker: { position: { lat: 52.009865, lng: -0.118092 } },
      address: {},
      postcode: "",
      organization_logo: [],
      front_image: [],
      tabsValue: "new_address",
      organization_addresses: [],
      hidingMap: true,
      levels: [],
      users: [],
      uploadUrl:
        apiUrl +
        "/api/uploadFile?notice&organization_id=" +
        this.$route.params.org_id,
      rules: {
        name: [
          {
            required: true,
            message: "Please input Org name",
            trigger: "change",
          },
          {
            min: 3,
            message: "Length should be at least 3",
            trigger: "change",
          },
        ],
        school_type: [
          {
            required: true,
            message: "Please select School type",
            trigger: "change",
          },
        ],
        password: [
          {
            required: false,
            message: "Please enter a password",
            trigger: "change",
          },
          {
            min: 6,
            message: "Please enter at least 6 characters",
            trigger: "change",
          },
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please enter user email",
            trigger: "change",
          },
        ],
        first_name: [
          {
            required: true,
            message: "Please enter first name",
            trigger: "change",
          },
        ],
        last_name: [
          {
            required: true,
            message: "Please enter last name",
            trigger: "change",
          },
        ],
        // phone: [
        //   {
        //     required: true,
        //     message: "Please enter phone",
        //     trigger: "change",
        //   },
        // ],
        // school_phone: [
        //   {
        //     min: 8,
        //     required: true,
        //     message: "Please enter valid number",
        //     trigger: "blur",
        //   },
        // ],
        // support_email: [
        //   {
        //     required: true,
        //     message: "Please enter valid email",
        //     trigger: "change",
        //   },
        // ],
      },
    };
  },
  components: {
    // CButton,
    "file-upload": VueUploadComponent,
    Autocomplete,
  },
  methods: {
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.type.substr(0, 6) === "image/") {
          if (newFile.xhr) {
            //  Get the response status code
            const response = newFile.xhr.response;
            this.form.organization_logo = response;

            setTimeout(() => {
              if (this.$refs.upload.active === false) {
                this.imagesLoading = false;
              }
            }, 500);
          }
        }
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (newFile.error == "") {
          this.imagesLoading = true;
          if (!this.$refs.upload.active) {
            new ImageCompressor(newFile.file, {
              quality: 0.9,
              maxHeight: 1200,
              success: (result) => {
                // Successfully deleted the error to write the new file
                this.$refs.upload.update(newFile, {
                  file: result,
                  error: "",
                  size: result.size,
                  type: result.type,
                });
                setTimeout(() => {
                  this.$refs.upload.active = true;
                }, 200);
              },
            });
          }
        }
      }
    },
    inputSchoolFrontImage: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.type.substr(0, 6) === "image/") {
          if (newFile.xhr) {
            //  Get the response status code
            const response = newFile.xhr.response;
            this.form.front_image = response;

            setTimeout(() => {
              if (this.$refs.uploadFrontImage.active === false) {
                this.imagesLoading = false;
              }
            }, 500);
          }
        }
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (newFile.error == "") {
          this.imagesLoading = true;
          if (!this.$refs.uploadFrontImage.active) {
            new ImageCompressor(newFile.file, {
              quality: 0.9,
              maxHeight: 1200,
              success: (result) => {
                // Successfully deleted the error to write the new file
                this.$refs.uploadFrontImage.update(newFile, {
                  file: result,
                  error: "",
                  size: result.size,
                  type: result.type,
                });
                setTimeout(() => {
                  this.$refs.uploadFrontImage.active = true;
                }, 200);
              },
            });
          }
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert("Your choice is not a picture");
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    openModal(value) {
      if (value === "locations") {
        this.hidingMap = false;
        this.getOrganizationAddresses();
      } else if (value === "structure") {
        this.schoolYearLookup();
      }
      this.$modal.show(value);
    },
    openOrgRelationships() {
      this.$modal.show(
        OrgRelationshipModal,
        {
          organization_id: parseInt(this.organization_id),
          orgType: this.form.organization_type,
          closeHandler: () => {
            // this.$modal.hide(SingleTravelFeature, { closedByButton: true });
            // reject();
          },
        },
        {
          draggable: false,
          transition: "fadeDown",
          // scrollable: true,
          // height: 500,
          adaptive: true,
          width: 700,
          minHeight: 500,
          height: "auto",
          // pivotY: 0
        }
      );
    },
    openOrgUsers() {
      this.$modal.show(
        OrgUsersModal,
        {
          organization_id: parseInt(this.organization_id),
          org_type: this.form.organization_type,
          closeHandler: () => {
            // this.$modal.hide(SingleTravelFeature, { closedByButton: true });
            // reject();
          },
        },
        {
          draggable: false,
          transition: "fadeDown",
          adaptive: true,
          width: 1250,
          minHeight: 500,
          height: "auto",
        }
      );
    },
    hideMap() {
      this.hidingMap = true;
    },
    hideModal(value) {
      this.$modal.hide(value);
      this.hidingMap = true;
    },
    setPlace(data) {
      if (!data.geometry) {
        return;
      }
      this.marker.position = {
        lat: data.geometry.location.lat(),
        lng: data.geometry.location.lng(),
      };
      this.centerPosition = {
        lat: data.geometry.location.lat(),
        lng: data.geometry.location.lng(),
      };
      this.zoomLevel = 17;
      this.$emit("newAddress", this.getAddress(data));
    },
    getAddress(place) {
      const fullAddress = place.formatted_address.split(",");
      this.newAddress = {
        latitude: this.marker.position.lat,
        longitude: this.marker.position.lng,
        street: place.address_components[0].long_name,
        city: place.address_components[1].long_name,
        country: place.address_components[3].long_name,
        address_line_1: fullAddress[0],
        address_line_2: fullAddress[1],
        postcode: place.address_components[0].short_name,
      };
      return {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        street: place.address_components[0].long_name,
        city: place.address_components[1].long_name,
        country: place.address_components[3].long_name,
        address_line_1: fullAddress[0],
        address_line_2: fullAddress[1],
        postcode: place.address_components[0].short_name,
      };
    },
    dragEnd(data) {
      const updateData = this.address;
      updateData.lat = data.latLng.lat();
      updateData.lng = data.latLng.lng();
      this.newAddress.latitude = data.latLng.lat();
      this.newAddress.longitude = data.latLng.lng();
      this.$emit("newAddress", JSON.parse(JSON.stringify(updateData)));
    },
    saveOrganization() {
      this.$refs["organizationform"].validate((valid) => {
        if (valid) {
          ApiService.generalApi.saveOrganization(this.form).then((resp) => {
            if (resp.data.id) {
              this.organization_id = resp.data.id;
              this.form.id = resp.data.id;
              this.$notify.success({
                title: "Success",
                message: "Saved",
              });
              this.$router.push('/members/organization/' + resp.data.id);
            } else {
              alert("Errors");
            }
          });
        } else {
          return false;
        }
      });
    },
    goToSchools() {
      this.$router.push("schools");
    },
    goBack() {
      this.$router.go(-1);
    },
    schoolYearLookup() {
      ApiService.generalApi.getDefaultYears().then((resp) => {
        this.levels = resp.data;
        this.getOrganizationAddresses();
        this.getOrgYears();
        // this.organization_addresses = resp.data.addresses;
        // this.getSchoolYears();
      });
    },
    getOrgYears() {
      ApiService.generalApi
        .getOrgGroups(this.organization_id, "STUDENT_YEAR")
        .then((response) => {
          const existingYearsObj = {};
          response.data.forEach((element) => {
            existingYearsObj[element.value] =
              element.organization_address_id === 0
                ? -1
                : element.organization_address_id;
          });
          this.years = existingYearsObj;
          this.levels.forEach((element) => {
            if (existingYearsObj[element.value]) {
              element.status = true;
              element.organization_address_id = existingYearsObj[element.value];
            }
          });
          this.levels = JSON.parse(JSON.stringify(this.levels));
        });
    },
    getSchoolYears() {
      ApiService.generalApi
        .getSchoolYears(this.organization_id)
        .then((resp) => {
          const existingYearsObj = {};
          resp.data.years.forEach((element) => {
            existingYearsObj[element.level] =
              element.organization_address_id === 0
                ? -1
                : element.organization_address_id;
          });

          this.years = existingYearsObj;
          this.levels.forEach((element) => {
            if (existingYearsObj[element.value]) {
              element.status = true;
              element.organization_address_id = existingYearsObj[element.value];
            }
          });
        });
    },
    getOrganizationAddresses() {
      this.loading = true;
      ApiService.generalApi
        .getOrganizationAddresses(this.organization_id)
        .then((resp) => {
          this.organization_addresses = resp.data;
          this.loading = false;
        });
    },
    saveOrganizationAddress() {
      if (!this.newAddress.name) {
        this.$notify.error({
          title: "Error",
          message: "Name is missing",
        });
        return;
      }

      this.newAddress.organization_id = this.organization_id;
      ApiService.generalApi
        .saveOrganizationAddress(this.newAddress)
        .then((resp) => {
          this.$notify.success({
            title: "Success",
            message: "Saved",
          });
          this.newAddress = {};
          this.organization_addresses.push(resp.data);
          this.tabsValue = "current_address";
          this.loading = true;
          setTimeout(() => {
            this.getOrganizationAddresses();
          }, 800);
        });
    },
    saveUser() {
      alert("test");
    },
    saveStructure() {
      if (this.validateStructure()) {
        const payload = {
          organization_id: this.organization_id,
          levels: this.levels,
        };
        ApiService.generalApi.storeStudentYears(payload);
        this.$notify.success({
          title: "Success",
          message: "Saved",
        });
        setTimeout(() => {
          this.hideModal("structure");
        }, 400);
      }
    },
    validateStructure() {
      let noErrors = true;
      this.levels.forEach((element) => {
        if (element.status == 1 && !element.organization_address_id) {
          noErrors = false;
        }
      });
      if (noErrors) {
        return true;
      } else {
        this.$notify.error({
          title: "Error",
          message: "Address not selected",
        });
        return false;
      }
    },
    rerender() {
      this.$forceUpdate();
    },
  },
  computed: {
    token: function () {
      return "Bearer " + this.$store.state.token;
    },
    accType: function () {
      return this.$store.state.accType;
    },
  },
  mounted() {
    const organizationId = this.$route.params.org_id;
    if (!isNaN(organizationId)) {
      ApiService.generalApi.getOrganization(organizationId).then((resp) => {
        this.form = resp.data;
        // this.form.first_name = resp.data.admins[0].first_name;
        // this.form.last_name = resp.data.admins[0].last_name;
        // this.form.phone = resp.data.admins[0].phone;
        // this.form.email = resp.data.admins[0].email;
        this.form.phone = resp.data.phone;
        this.form.email = resp.data.email;
        this.form.registration_type = resp.data.registration_type;
        this.form.total_students = resp.data.total_students;
        this.form.launch_code = resp.data.launch_code;
        this.form.code = resp.data.code;
        this.form.staff_code = resp.data.staff_code;
        // this.form.council_id = resp.data.council_id;
        // this.form.support_email = resp.data.email;
        this.organization_id = organizationId;
        this.organization_logo = [{ url: resp.data.logo_url }];
        this.front_image = [{ url: resp.data.front_image_url }];
      });
    }
  },
});
